import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { BounceInDownButton } from '../../animation/bounceIn';
import { useUpdateProfile } from './api/apiSecuritysettings';
import { Avatar, CircularProgress } from '@mui/material';
import { Mail, User } from 'lucide-react';
import { stringAvatar } from '../../lib/avatar';
import { useModalContext } from '../../contexts/ModalContext';
import { PageLoader } from '../../lib/loader';


const schema = yup.object().shape({
    name: yup.string()
        .min(3, 'Name must be at atleast 3 characters')
        .required('Name is required'),
    email: yup.string().required('Email is required'),
    profilePicture: yup.mixed()
        .test("required", "Profile is required", (file) => !!file),
})

function ProfileSettings() {

    const [profileimg, setProfileimg] = useState('');
    const { profiledata, commonloader } = useModalContext();

    const updateProfilemutation = useUpdateProfile();
    const { control, handleSubmit, formState: { errors }, reset, setValue, setError, clearErrors } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            name: "",
            email: "",
            profilePicture: "",
        }
    });

    useEffect(() => {
        if (profiledata) {
            reset(profiledata);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profiledata])

    const readFileAsync1 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = btoa(reader.result);
                resolve(`data:${file.type};base64,${base64Data}`);
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file);
        });
    }

    const handleProfile = (event) => {
        let img = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const imgCheck = new Image();
            imgCheck.src = event.target.result;
            imgCheck.onload = async () => {
                if (imgCheck.width <= 6000 && imgCheck.height <= 6000) {

                    if (img.size < 2 * 1024 * 1024) {
                        await readFileAsync1(img)
                        setProfileimg(img);
                        setValue("profilePicture", img)
                    } else {
                        setError("profilePicture", { message: "Image Size Must be Less than 2MB." });
                    }
                } else {
                    setError("profilePicture", { message: "Image Dimensions should be 6000 x 6000 Pixels." });
                }
            };

            imgCheck.onerror = (error) => {
            };
        }
        reader.onerror = (error) => {
        };
        reader.readAsDataURL(img);
    }

    const onSubmit = async (data) => {
        let formData = new FormData();
        formData.append("email", data.email)
        formData.append("name", data.name)
        formData.append("profilePicture", data.profilePicture)
        await updateProfilemutation.mutateAsync(formData)
    }


    return (
        commonloader ? (
            <PageLoader />
        ) : (
            <BounceInDownButton>
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-xl-6 col-xxl-5">
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="d-flex justify-content-center">
                                <Avatar {...stringAvatar('Admin')}
                                    src={profileimg ? URL?.createObjectURL(profileimg) : profiledata?.profilePicture}
                                    sx={{ width: 150, height: 150 }}
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label" htmlFor="crntpw">Profile Image</label>
                                <input
                                    name='profilePicture' className="form-control"
                                    accept='.jpg,.png,.jpeg'
                                    type="file" id="formFileMultiple1"
                                    onChange={async (e) => {
                                        try {
                                            let img = e.target.files[0]
                                            const reader = new FileReader();
                                            clearErrors("profilePicture")
                                            setValue("profilePicture", null)
                                            setProfileimg(null)
                                            reader.onload = (event) => {
                                                const bytes = new Uint8Array(event.target.result);
                                                if ((bytes[0] === 0x89 && bytes[1] === 0x50) ||
                                                    (bytes[0] === 0xFF && bytes[1] === 0xD8)) { // png, apng, jpg, jpeg
                                                    handleProfile(e)
                                                } else {
                                                    setError("profilePicture", { message: 'Please select image file' })
                                                }
                                            };
                                            reader.onerror = (error) => { };
                                            reader.readAsArrayBuffer(img);
                                        } catch (e) { }
                                    }}
                                />
                                {errors.profilePicture && <p className='errMsg'>{errors.profilePicture.message}</p>}
                            </div>
                            <div className='mb-3'>
                                <label className="form-label" htmlFor="crntpw">Name</label>
                                <div className="input-group">
                                    <button type="button" className="btn p-0 input-group-icon border-0">
                                        <User size={20} color='#aaa9a9' />
                                    </button>
                                    <Controller name='name' control={control} render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control"
                                            placeholder='Enter your name'
                                            autoComplete='off'
                                        />
                                    )} />
                                </div>
                                {errors.name && <p className="errMsg">* {errors.name.message}</p>}
                            </div>
                            <div className='mb-3'>
                                <label className="form-label" htmlFor="crntpw">E-mail</label>
                                <div className="input-group">
                                    <button type="button" className="btn p-0 input-group-icon border-0">
                                        <Mail size={20} color='#aaa9a9' />
                                    </button>
                                    <Controller name='email' control={control} render={({ field }) => (
                                        <input
                                            {...field}
                                            className="form-control"
                                            placeholder="Enter email address"
                                            autoComplete='off'
                                            disabled={sessionStorage.getItem('role') !== "all"}
                                        />
                                    )} />
                                </div>
                            </div>
                            <div className="d-grid crPgbtn pt-2">
                                <button className="btn btn-primary"
                                    disabled={updateProfilemutation.isLoading}
                                >
                                    {updateProfilemutation.isLoading ? (
                                        <CircularProgress style={{ color: "#fff" }} size={20} />
                                    ) : (
                                        "Update Profile"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </BounceInDownButton>
        )

    );

}

export default ProfileSettings;